module.exports = __webpack_public_path__ + "static/media/step-forward.f5e1a4d3.svg";